/**
 * Temperature and Humidity Sensor Template
 * For environmental monitoring sensors (read-only devices)
 */

import {
	createTemperatureRangeCondition,
	createHumidityRangeCondition,
	createBatteryLevelCondition,
	createTemperatureChangedTrigger,
	createHumidityChangedTrigger,
	createTemperatureThresholdTrigger,
	createHumidityThresholdTrigger,
	createLowBatteryTrigger,
} from '../../common/sensorMonitoring.js';

/**
 * Create temperature and humidity sensor template
 * @returns {Object} Scene capabilities for temperature/humidity sensor
 */
export function createTemperatureHumiditySensorTemplate() {
	return {
		deviceType: 'temperature_humidity_sensor',
		channels: ['sensor:0'],

		actions: {
			// Sensors are read-only devices, no actions available
			// Actions would be handled by connected devices based on sensor triggers
		},

		conditions: {
			temperatureRange: createTemperatureRangeCondition(),
			humidityRange: createHumidityRangeCondition(),
			batteryLevel: createBatteryLevelCondition(),
		},

		triggers: {
			temperatureChanged: createTemperatureChangedTrigger(),
			humidityChanged: createHumidityChangedTrigger(),
			temperatureThreshold: createTemperatureThresholdTrigger(),
			humidityThreshold: createHumidityThresholdTrigger(),
			lowBattery: createLowBatteryTrigger(),
		},
	};
}
